export const BRKT_PRICE_PERIOD = (start: string, end: string) => `
{
	brkt_price_period(start:"${start}",end:"${end}") {
		date
		conv_rate
		eth_price
		brkt_eth_price
		brkt_supply
		total_value
	}
}

`

